var map = {
	"./biome1.png": 5841,
	"./biome2.png": 8353,
	"./biome3.png": 1252,
	"./biome3b.png": 4585,
	"./biome4.png": 1332,
	"./biomes.jpg": 1019,
	"./cartepostalealien.jpg": 5098,
	"./cartepostalecrotte.jpg": 4342,
	"./cartepostalejambes.png": 5958,
	"./cartepostalepetitefille.jpg": 1172,
	"./cartepostalesouris.jpg": 1556,
	"./cartepostaletour.png": 6207,
	"./sphinxcroquis.jpg": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3348;